import { render, staticRenderFns } from "./CiBrandVorschau.vue?vue&type=template&id=d11c63c6&scoped=true"
import script from "./CiBrandVorschau.vue?vue&type=script&lang=js"
export * from "./CiBrandVorschau.vue?vue&type=script&lang=js"
import style0 from "./CiBrandVorschau.vue?vue&type=style&index=0&id=d11c63c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11c63c6",
  null
  
)

export default component.exports